"use client"

import { useLocale } from "next-intl"
import dynamic from "next/dynamic"
import { extractProperty } from "utils"
import { useIsDesktop } from "../common/bit/MediaQueries"
import MapLocaleProvider from "../MapLocaleProvider"
import PortMapContent from "./PortMapContent"
import { LoadingOverlay, LoadingSpinner, StyledSection } from "./styled"
import { PortMapLocationsOnMapProps } from "./types"

const { GOOGLE_API_KEY } = process.env

// Inner wrapper that handles client-side only rendering
const PortMapInner = ({ ports, data }: PortMapLocationsOnMapProps) => {
  const title = extractProperty(data, "title")
  const locale = useLocale()
  const isDesktop = useIsDesktop()

  return (
    <MapLocaleProvider
      apiKey={GOOGLE_API_KEY || "AIzaSyD2AanBqJJ8WM8JL6LJ3jjbYkUgD4Mk0Cc"}
      locale={locale}
    >
      <PortMapContent ports={ports || []} title={title} isDesktop={isDesktop} />
    </MapLocaleProvider>
  )
}

// Dynamic import with SSR disabled to prevent hydration issues
const PortMapNoSSR = dynamic(() => Promise.resolve(PortMapInner), {
  ssr: false,
  loading: () => (
    <LoadingOverlay>
      <LoadingSpinner />
    </LoadingOverlay>
  ),
})

const PortMapLocationsOnMap = ({ data, ports }: PortMapLocationsOnMapProps) => {
  // in case data fields are empty, return null
  if (!ports || ports.length === 0) {
    return null
  }

  return (
    <StyledSection id="port-map-locations-on-map">
      <PortMapNoSSR data={data} ports={ports} />
    </StyledSection>
  )
}

export default PortMapLocationsOnMap
